'use client';

import { useEffect } from 'react';
import { EventScheduledEvent, useCalendlyEventListener } from 'react-calendly';

import {
  adaptCalendlyLink,
  createPrefillCalendly,
  createUtmCalendly,
} from '@/utils/calendly';
import { getTrackingCookies } from '@/utils/cookies';
import * as gtm from '@/utils/gtm';

export function useCalendly({
  link,
  onSubmit,
  company,
  firstName,
  lastName,
  email,
  phone,
}: {
  link: string;
  onSubmit: (e: EventScheduledEvent) => void;
  company?: string;
  firstName?: string;
  email?: string;
  lastName?: string;
  phone?: string;
}) {
  const calendlyLink = adaptCalendlyLink(link)!;
  const utmCalendly = createUtmCalendly(getTrackingCookies());
  const prefillCalendly = createPrefillCalendly({
    company,
    firstName,
    lastName,
    email,
    phone,
  });

  const handleDateAndTimeSelected = () => {
    gtm.pushEvent('calendly_select_date_and_time');
  };

  const handleEventScheduled = (e: EventScheduledEvent) => {
    gtm.pushEvent('calendly_meeting_scheduled');
    onSubmit(e);
  };

  useCalendlyEventListener({
    onDateAndTimeSelected: handleDateAndTimeSelected,
    onEventScheduled: handleEventScheduled,
  });

  useEffect(() => {
    gtm.pushEvent('calendly_view');
  }, []);

  return { calendlyLink, utmCalendly, prefillCalendly };
}
